export default {
    lang: "乌克兰语",
    application: {
        name: "Система публікації інформації",
    },
    ajaxTip: {
        success: "Успішно",
        error: "Не вдалося",
        noAccess: "Немає доступу до цього ресурсу",
        notFound: "Запитуваний ресурс не існує",
        serverBusy: "Сервер навантажений",
        timeOut: "Тайм-аут",
    },
    menu: {
        home: "Головна",
        template: "Керування шаблонами",
        program: "Керування програмами",
        playplan: "План відтворення",
        device: "Керування пристроями",
        "source-material": "Керування матеріалами",
        material: "Матеріали",
        checkManage: "Керування перевіркою",
        setting: "Налаштування",
        usercenter: "Особистий кабінет",
        adminManage: "Керування пристроями",
        schedule: "Планові завдання",
        capitalassets: "Керування капітальними активами",
        modifyPassword: "Змінити пароль",
        logout: "Вийти з системи",
        "add": "Додати",
        "edit": "Редагувати",
        "delete": "Видалити",
        "view": "Переглянути",
        "menu_1": "Головна",
        "menu_2": "Керування пристроями",
        "menu_3": "Редагувати (Розширені налаштування - Базове редагування - Змінити мережу)",
        "menu_4": "Миттєві команди",
        "menu_5": "Редагувати (Перенести в інший відділ)",
        "menu_6": "Стратегія",
        "menu_7": "Налаштування гучності",
        "menu_8": "Налаштування яскравості",
        "menu_9": "Налаштування завантаження",
        "menu_10": "Налаштування сну",
        "menu_11": "Властивості пристрою",
        "menu_12": "Редагувати/Додати",
        "menu_13": "Керування програмами",
        "menu_14": "Історія публікацій",
        "menu_15": "Видалити (Пакетно/По окремо)",
        "menu_16": "Програми в процесі публікації",
        "menu_17": "Групування",
        "menu_19": "Список програм",
        "menu_20": "Редагування контенту",
        "menu_21": "Копіювати програму",
        "menu_23": "Опублікувати програму",
        "menu_24": "Керування матеріалами",
        "menu_25": "Завантажити",
        "menu_28": "Швидка публікація",
        "menu_29": "Керування шаблонами",
        "menu_30": "Загальні шаблони",
        "menu_31": "Використати зараз",
        "menu_32": "Мої шаблони",
        "menu_33": "Опублікувати в загальні шаблони",
        "menu_35": "Історія спільного використання",
        "menu_36": "Керування аудитом",
        "menu_37": "Аудит програм",
        "menu_38": "Аудит (Затвердити/Відхилити)",
        "menu_39": "Аудит матеріалів",
        "menu_41": "Історія аудиту (Оператор)",
        "menu_42": "Історія аудиту (Аудитор)",
        "menu_43": "Переглянути кількість затверджень",
        "menu_44": "Керування організацією",
        "menu_45": "Керування журналами",
        "menu_46": "Журнали відтворення",
        "menu_47": "Журнали публікацій",
        "menu_48": "Журнали помилок",
        "menu_49": "Журнали операцій",
        "menu_50": "Журнали файлів",
        "menu_51": "Журнали входу в систему",
        "menu_52": "Затвердження контенту",
        "menu_53": "Місце для зберігання",
        "menu_54": "Організаційна структура",
        "menu_55": "Права ролей",
        "menu_56": "Авторизація",
        "menu_57": "Переглянути (Права авторизації)",
        "menu_58": "Члени організації",
        "menu_60": "Скинути паролі підпорядкованих користувачів",
        "menu_61": "Керування активами",
        "menu_62": "Мій баланс",
        "menu_63": "Переглянути (Деталі коштів)",
        "menu_64": "Мій трафік даних",
        "menu_65": "Переглянути (Деталі трафіку даних)",
        "menu_66": "Купити трафік даних",
        "menu_67": "Моя ємність",
        "menu_68": "Мої пристрої",
        "menu_69": "Деталі замовлення",
        "menu_70": "Переглянути (Поповнити рахунок)",
        "menu_71": "Переглянути (Куплені шаблони)",
        "menu_72": "Переглянути (Куплений трафік даних)",
        "menu_73": "Інші права",
        "menu_74": "Переглянути (Статистика матеріалів та програм)",
        "menu_75": "Переглянути (Активи)",
        "menu_76": "Переглянути (Хмарний трафік даних/Статистика)",
        "menu_77": "Переглянути (Статистика онлайн пристроїв)"
    },
    login: {
        terminalServiceSystem: "Розумна система обслуговування терміналів",
        accountLogin: "Вхід за обліковим записом",
        register: "Реєстрація",
        accountLoginTip: "Вхід для наявних облікових записів",
        scanQRCode: "Скануйте QR-код",
        readAndAgree: "Я прочитав(ла) і погоджуюсь",
        readAndAgreeLink: "Умови обслуговування користувачів",
        readAndAgreeAgreement: "Будь ласка, прочитайте та погодьтеся з умовами обслуговування користувачів",
        forgetpassword: "Забули пароль?",
        resetpassword: "Скинути пароль",
        phoneEmptyTip: "Введіть номер мобільного телефону",
        nextStep: "Наступний крок",
        title: "Ласкаво просимо до системи",
        submit: "Увійти",
        userName: "Обліковий запис",
        password: "Пароль",
        userNameEmptyTip: "Введіть обліковий запис",
        passwordEmptyTip: "Введіть пароль",
        passwordFormatTip: "Введіть правильний формат паролю",
        passwordIsOk: "Підтвердіть пароль",
        passwordSign: "Введіть пароль",
        codeTip: "Введіть код підтвердження",
        phone: "Номер телефону не може бути порожнім",
        code: "Код підтвердження не може бути порожнім",
        nickname: "Назва компанії не може бути порожньою",
        pass: "Пароль не може бути порожнім",
        pwdMessage: "Довжина паролю 8~20 символів, не містить пробілів і обов'язково включає 3 з наступних типів: великі літери, малі літери, цифри, спеціальні символи",
        pwdMessage01: "Введіть пароль, що складається з літер і цифр, не менше восьми символів",
        pwdMessage02: "Довжина паролю 8-20 символів",
        pwdMessage03: "Пароль не може містити пробілів",
        pwdMessage04: "Пароль обов'язково має включати 3 з наступних типів: великі літери, малі літери, цифри, символи",
        newpassempty: "Новий пароль не може бути порожнім",
        newpass: "Два введені паролі не збігаються",
        getcode: "Отримати код підтвердження",
        format: "Неправильний формат номера мобільного телефону",
        chongfa: "Повторна відправка через сек",
        isSend: "Відправлено",
        noregister: "Немає облікового запису? Зареєструватися зараз",
        Mobile: "Номер мобільного телефону",
        verificationcode: "Код підтвердження",
        petname: "Псевдонім",
        Quickregistration: "Швидка реєстрація",
        xiugaimima: "Змінити пароль",
        jiumima: "Старий пароль",
        xinmima: "Новий пароль",
        zaicishuruxinmima: "Повторіть новий пароль",
        xiugaichenggong: "Змінено успішно",
        xiugaishoujihao: "Змінити номер телефону",
        dengluzhanghao: "Обліковий запис для входу",
        gongsiid: "ID компанії",
        yonghunicheng: "Псевдонім користувача",
        chuangjianshijian: "Час створення",
        gongsimingcheng: "Назва компанії",
        denglumima: "Пароль для входу",
        jianyi: "Рекомендується використовувати пароль, що складається з літер і цифр",
        shezhimima: "Встановити пароль",
        shezhishoujihao: "Змінити/встановити номер телефону",
        yibangding: "Прив'язано",
        weibangding: "Не прив'язано",
        zhanghuanquan: "Безпека облікового запису",
        yonghuxinxi: "Інформація про користувача",
        zhuceSucMsg: "Вітаємо, реєстрація успішна!",
        verificationcodeSucMsg: "Код підтвердження відправлено успішно！",
        requiredIsEmpty: "Обов'язкові поля не можуть бути порожні！",
        emailObj: {
            title: "Електронна пошта",
            tit: "Вхід за електронною поштою",
            tip: "Введіть адресу електронної пошти",
            formatTip: "Введіть правильний формат адреси електронної пошти",
        },
        phoneObj: {
            title: "Номер мобільного телефону",
            tit: "Вхід за номером телефону",
            tip: "Введіть номер мобільного телефону",
            formatTip: "Введіть правильний формат номера мобільного телефону",
        },
        emailOrPhoneObj: {
            title: "Електронна пошта або номер телефону",
            tit: "Вхід за електронною поштою або номером телефону",
            tip: "Введіть електронну пошту або номер телефону",
            formatTip: "Введіть правильний формат електронної пошти або номера телефону",
        },
        wechatObj: {
            title: "WeChat",
            tit: "Вхід через WeChat",
        },
        googleObj: {
            title: "Google",
            tit: "Вхід через Google",
        },
        confirm: "Підтвердити",
        confirmSubmit: "Підтвердити відправку",
        cancel: "Скасувати",
        close: "Закрити",
        bindSucMsg: "Прив'язано успішно",
        toContinueBindAccount: "Продовжити для завершення прив'язки стороннього облікового запису",
        bindTip01: "Немає облікового запису? Створіть його",
        bindTip02: "Є обліковий запис",
        bindTip03: "Поточний сторонній обліковий запис не прив'язаний до облікового запису платформи. Будь ласка, прив'яжіть наявний обліковий запис або зареєструйте та прив'яжіть новий, щоб наступного разу увійти швидше.",
        bindTip04: "Прив'язати наявний обліковий запис",
        bindTip05: "Зареєструватися та прив'язати новий обліковий запис",
        bindTip06: "Ви авторизувалися через сторонній сервіс, заповніть наступну інформацію для входу, щоб завершити прив'язку",
        bindSubmit: "Відправити прив'язку",
        enterAccountTip: "Введіть назву облікового запису",
        RegisterAndBind: "Зареєструватися та прив'язати",
        loginErr: "Невірне ім'я користувача або пароль！",
        usercenter: "Особистий кабінет",
        pleaseInputName: "Введіть назву",
        operationSuccess: "Операція успішна！",
        edit: "Редагувати",
        xiugai: "Змінити",
        userData: "Особисті дані",
        changePassword: "Зміна паролю",
        account: "Обліковий запис",
        userName01: "Ім'я користувача",
        phoneNumber: "Номер телефону",
        role: "Роль",
        createTime: "Час створення",
        genghuang: "Замінити",
        bangding: "Прив'язати",
        unbind: "Відв'язати",
        plesaseSelectBindingType: "Виберіть тип прив'язки",
        pleaseConfirmCont: "Підтвердіть, що я прочитав(ла) цей вміст",
        confirmReadCont: "Я прочитав(ла) цей вміст",
        frequentTip: "Забагато операцій за короткий час, спробуйте пізніше!",
        zhuxiaoBtn: "Відключити обліковий запис",
        zhuxiaoTitle: "Відключення облікового запису",
        querenZhuxiao: "Підтвердити відключення",
        jiXu: "Продовжити",
        sendCodeBtn: "Відправити код підтвердження",
        passwordIsNotOldPassword: "Підтверджений пароль не збігається з новим паролем",
        passwordIsOldPassword: "Новий пароль збігається зі старим",
        passFormatError: "Введіть правильний формат паролю",
        oldPassWord: "Старий пароль",
        newPassWord: "Новий пароль",
        inputPlaceholder: "Введіть",
        confirmPassword: "Підтвердити пароль",
        zhuxiaoTip: `
            1、Відключення облікового запису є незворотною операцією. Після відключення ви не зможете увійти та використовувати цей обліковий запис або сторонні облікові записи, зареєстровані через нього. Зробіть резервну копію всієї пов'язаної інформації та даних самостійно.
            2、Перед відключенням облікового запису переконайтеся, що всі активи очищені та не має жодних суперечок. Після відключення облікового запису ви втрачаєте всі права власності на активи та права в межах цього облікового запису, і їх неможливо відновити або віднайти.
            3、Якщо за один номер мобільного телефону зареєстровані облікові записи були відключені понад 3 рази, цей номер телефону не може бути використаний для реєстрації нового облікового запису та прив'язки до будь-яких інших облікових записів.
        `
    },
    home: {
        title: "Головна",
        quickOperation: "Швидкі операції",
        addDevice: "Додати пристрій",
        publishProgram: "Опублікувати програму",
        publishMaterial: "Опублікувати матеріали",
        makeProgram: "Створити програму",
        uploadMaterial: "Завантажити матеріали",
        todayData: "Дані за сьогодні (оновлюються щогодини)",
        playNumChart: "Статистика кількості відтворень",
        deviceOnlineStatus: "Статус підключення пристроїв",
        onLineDevice: "Пристрої в мережі",
        unLineDevice: "Пристрої поза мережею",
        programPlayTime: "Статистика тривалості відтворення програм",
        downloadSoft: "Завантаження програмного забезпечення",
        adminApp: "Мобільний клієнт для адміністратора",
        playerApp: "Термінал відтворення публікацій",
        downloadAdminApp: "Натисніть для завантаження клієнта",
        downloadPlayerApp: "Натисніть для завантаження термінала відтворення",
        aboutUs: "Про нас",
        userManual: "Інструкція користувача",
        message: "Залишити повідомлення",
    },
    device: {
        inputPlaceholder: "Введіть",
        selectPlaceholder: "Виберіть",
        osTypeStr: "Операційна система терміналу",
        onLineStatus: "Статус підключення",
        dpi: "Роздільна здатність",
        companyDeptIdName: "Приналежність до установи",
        deviceGroupIdName: "Приналежність до групи",
        editOrMove: "Редагувати/Перемістити",
        loanOriginationFee: "Комісія за видачу кредиту",
        strategyInfoLook: "Перегляд інформації про стратегію",
        programLook: "Перегляд програм",
        addEquipments: "Додати пристрої",
        luminanceSet: "Керування яскравістю",
        terminal: "Налаштування терміналу",
        transferCompany: "Перенести до іншого відділу",
        releasedProgram: "Опублікувати програму",
        screenshot: "Зробити скріншот",
        changeGroup: "Змінити групу",
        defaultGroup: "За замовчуванням",
        operation: "Операції",
        edit: "Редагувати",
        saveEdit: "Зберегти зміни",
        add: "Додати",
        save: "Зберегти",
        setting: "Налаштування",
        program: "Програми",
        unbind: "Відв'язати",
        sleep: "Перевести в режим спові",
        wakeup: "Прокинути",
        restart: "Перезапустити",
        shutdown: "Вимкнути",
        reportLog: "Надіслати журнали",
        clearPlayData: "Очистити дані термінала відтворення",
        offlineWarn: "Цей пристрій поза мережею, повторіть спробу після підключення!",
        confirmUnbind: "Підтвердити відв'язку",
        confirmReset: "Підтвердити очищення",
        confirmDelete: "Підтвердити видалення",
        delete: "Видалити",
        cancelDelete: "Скасувати видалення",
        confirmResetSuccess: "Очищено успішно",
        confirm: "Підтвердити",
        cancel: "Скасувати",
        operationSuccess: "Операція успішна",
        unbindSuccess: "Відв'язано успішно",
        pleaseSelectDevice: "Виберіть пристрій",
        pleaseSelectOnlineDevice: "Виберіть пристрій, що знаходиться в мережі",
        confirmMixOperation: "Серед вибраних пристроїв є пристрої поза мережею, налаштування не застосуються до них. Продовжити?",
        pleaseSelectDate: "Виберіть дату",
        reportSuccess: "Надіслано успішно",
        deviceSetting: "Налаштування пристрою",
        default: "За замовчуванням",
        all: "Всі",
        deviceList: "Список пристроїв",
        addDevice: "Додати пристрій",
        department: "Відділи установи",
        deviceType: "Роздільна здатність",
        osType: "Операційна система терміналу",
        onlineState: "Статус підключення",
        online: "В мережі",
        offline: "Поза мережею",
        notActive: "Не активовано",
        search: "Введіть ключове слово",
        batchOperation: "Пакетні операції",
        allDevices: "Всі пристрої",
        deviceAttribute: "Атрибути пристрою",
        selectReportDate: "Виберіть дату звіту",
        inputName: "Введіть назву",
        inputWidth: "Введіть ширину",
        inputHeight: "Введіть висоту",
        inputResolutionRatio: "Введіть ціле число більше 0!",
        inputSort: "Введіть порядок сортування",
        serialNum: "Порядковий номер",
        name: "Назва",
        width: "Ширина",
        height: "Висота",
        resolutionRatio: "Роздільна здатність",
        inputResolutionRatioName: "Введіть назву роздільної здатності",
        sort: "Порядок сортування",
        personal: "Особисте",
        system: "Системне",
        type: "Тип",
        systemDefaultSettingUneditable: "Системні налаштування за замовчуванням не можна редагувати!",
        systemDefaultSettingUnDeletable: "Системні налаштування за замовчуванням не можна видаляти!",
        newz: "Додати",
        total: "Всього",
        totalNum: "шт.",
        strategyName: "Назва стратегії",
        associatedTerminalNum: "Кількість пов'язаних терміналів",
        createTime: "Час створення",
        pleaseSelectStrategy: "Виберіть стратегію！",
        onlySelectOneData: "Можна вибрати лише один запис！",
        downloadStrategy: "Завантажити стратегію",
        inputStrategyName: "Введіть назву стратегії",
        luminanceControl: "Керування яскравістю",
        volumeStrategy: "Стратегія гучності",
        saveSuccess: "Збережено успішно",
        screenAngle: "Поворот екрана(°)",
        startTime: "Час початку",
        endTime: "Час закінчення",
        repeat: "Повторювати",
        monday: "Понеділок",
        tuesday: "Вівторок",
        wednesday: "Середа",
        thursday: "Четвер",
        friday: "П'ятниця",
        saturday: "Субота",
        sunday: "Неділя",
        everyday: "Щодня",
        downloadSpeed: "Швидкість завантаження",
        inputDownloadSpeed: "Введіть швидкість завантаження",
        operator: "Операції",
        pleaseSelectDeleteData: "Виберіть дані для видалення！",
        confirmBatchDelete: "Підтвердити пакетне видалення？",
        pleaseInputName: "Введіть назву",
        detailSetting: "Детальні налаштування",
        weekPlan: "Недільний план",
        specialDateSetting: "Налаштування спеціальних дат",
        weekdayInfo: "День тижня є обов'язковим!",
        volumeInfo: "Гучність є обов'язковою!",
        timeError: "Невірний вибір часу!",
        editSuccess: "Редагування успішне！",
        addSuccess: "Додавання успішне！",
        addSpecialPlan: "Додати спеціальний план стратегії",
        downloadSpeedInfo: "Швидкість завантаження:(0 означає заборону завантаження)",
        pleaseSelectStartTime: "Виберіть час початку",
        pleaseSelectEndTime: "Виберіть час закінчення",
        luminanceError: "Введіть правильне значення яскравості！",
        defaultLuminance: "Яскравість за замовчуванням",
        luminance: "Рівень яскравості",
        defaultLuminanceInfo: "Яскравість за замовчуванням(100 - максимальна, 0 - мінімальна)",
        volume: "Гучність",
        saveLuminance: "Зберегти яскравість",
        changeSuccess: "Змінено успішно！",
        changeNetwork: "Змінити мережу",
        netName: "Назва мережі",
        nameempty: "Назва мережі не може бути порожньою",
        currentNetwork: "Поточна мережа",
        ipAddress: "IP-адреса",
        dailyMode: "Режим щодня",
        weeklyMode: "Режим за тижнями",
        turnOnTime: "Час увімкнення",
        turnOffTime: "Час вимкнення",
        startSleep: "Початок спові",
        endSleep: "Кінець спові",
        batchDelInfo: "Підтвердити видалення вибраних елементів？",
        timeCannotBeEmpty: "Час не може бути порожнім!",
        startUp: "Увімкнути",
        shutDown: "Вимкнути",
        volumeSize: "Рівень гучності",
        defaultVolume: "Гучність за замовчуванням(100 - максимальна, 0 - без звуку)",
        chooseStartTime: "Виберіть час початку",
        chooseEndTime: "Виберіть час закінчення",
        saveVolume: "Зберегти гучність",
        screenRotationUnSaved: "Поворот екрана не збережено",
        volumeSettingUnSaved: "Налаштування гучності не збережено",
        luminanceSettingUnSaved: "Налаштування яскравості не збережено",
        confirmClosePopup: "Підтвердити закриття цього вікна?",
        volumeSettingSuccess: "Налаштування гучності змінено успішно",
        luminanceSettingSuccess: "Налаштування яскравості змінено успішно",
        advancedSettingUnSaved: "Розширені налаштування не збережено",
        settingTitle: "Налаштування терміналу",
        volumeSetting: "Налаштування гучності",
        luminanceSetting: "Налаштування яскравості",
        downloadSetting: "Налаштування завантаження",
        sleepSetting: "Налаштування спові",
        onOffSetting: "Плановане увімкнення/вимкнення",
        screenRotation: "Поворот екрана",
        namingError: "Помилка іменування, ім'я файлу не може містити пробілів！",
        deleteSuccess: "Видалено успішно",
        deleteFolder: "Видалити папку",
        pleaseInputDeviceName: "Введіть назву пристрою",
        pleaseInputDeviceId: "Введіть ID пристрою",
        discoverDevice: "Знайти пристрої",
        deviceId: "ID пристрою",
        bound: "Прив'язано",
        bind: "Прив'язати",
        noDevice: "Пристроїв немає",
        refresh: "Оновити",
        manualAdd: "Додати вручну",
        deviceGroup: "Категорія пристроїв",
        pleaseSelectGroup: "Виберіть групу！",
        deviceName: "Назва пристрою",
        goAdd: "Перейти до додавання",
        close: "Закрити",
        bindCountInsufficient: "Недостатньо кількості можливих прив'язок, будь ласка, збільште кількість пристроїв перед додаванням！",
        displayNumber: "Відображуваний номер",
        groupName: "Назва групи",
        pleaseSelectGroupName: "Введіть назву групи！",
        moveGroup: "Перемістити до групи",
        longitude: "Довгота",
        latitude: "Широта",
        nationality: "Національність",
        province: "Провінція",
        city: "Місто",
        county: "Район",
        outNetIp: "Зовнішня IP-адреса",
        inNetIp: "Внутрішня IP-адреса",
        companyName: "Назва підприємства",
        Info: "Деталі",
        android: "Android",
        win: "Windows",
        osVersion: "Версія системи",
        softwareVersion: "Версія програмного забезпечення",
        diskSize: "Розмір диска",
        useSize: "Використаний розмір",
        macAddr: "MAC-адреса",
        longitudeLatitudeInfo: "Довгота та широта повинні бути одночасно порожніми або заповненими!",
        terminalName: "Назва терміналу",
        terminalGroup: "Група терміналів",
        reportJournal: "Чи надсилати журнали",
        systemVersion: "Версія системи",
        storageSpace: "Простір для зберігання",
        resolution: "Роздільна здатність",
        runningMemory: "Оперативна пам'ять",
        model: "Модель",
        registerStatus: "Статус реєстрації",
        password: "Пароль",
        passwordInfo: "Введіть 6 до 18 літер або цифр!",
        group: "Група",
        address: "Адреса",
        remark: "Примітка",
        renewalPeriod: "Період поновлення",
        money: "Вартість",
        latitudeInfo: "Введіть правильну широту!",
        totalPayment: "Загальна сума",
        longitudeInfo: "Введіть правильну довготу!",
        setMeal: "Пакет",
        number: "Кількість",
        programName: "Назва програми",
        playStatus: "Статус відтворення",
        playType: "Спосіб відтворення",
        play: "Відтворювати",
        pause: "Призупинити",
        playTime: "Час відтворення",
        programDeleted: "Програма видалена",
        playSuccess: "Програма запланована для відтворення",
        pauseSuccess: "Призупинено успішно",
        playCycle: "Циклічне відтворення",
        playInsert: "Вставне відтворення",
        withdrawSuccess: "Скасовано успішно",
        withdrawInfo: "Спочатку виберіть програму для скасування！",
        programBelong: "Приналежність до програми",
        checkAll: "Вибрати все",
        batchDel: "Пакетне видалення",
        delConfirm: "Підтвердити видалення вибраних елементів？",
        check: "Вибрано",
        noProgram: "Програм немає",
        details: "Деталі",
        screenshotFail: "Не вдалося зробити скріншот",
        policyName: "Назва політики",
        terminalNum: "Кількість пов'язаних терміналів",
        powerStrategy: "Стратегія живлення",
        pleaseSelectDepartment: "Виберіть відділ！",
        screenshotControl: "Керування скріншотами",
        未激活: "Не активовано",
        已激活: "Активовано",
        未绑定: "Не прив'язано",
        已绑定: "Прив'язано",
    },
    programManage: {
        programList: "Список програм",
        publishProgram: "Історія публікації програм",
        week1: "Понеділок",
        week2: "Вівторок",
        week3: "Середа",
        week4: "Четвер",
        week5: "П'ятниця",
        week6: "Субота",
        week7: "Неділя",
        monday: "Понеділок",
        tuesday: "Вівторок",
        wednesday: "Середа",
        thursday: "Четвер",
        friday: "П'ятниця",
        saturday: "Субота",
        sunday: "Неділя",
        name: "Назва",
        preview: "Перегляд",
        playDeviceNum: "Кількість пристроїв для відтворення",
        copyDeviceCode: "Натисніть для копіювання",
        osType: "Тип системи",
        playDate: "Дата відтворення",
        playWeek: "Тиждень відтворення",
        everyday: "Щодня",
        start: "від",
        end: "до",
        playOperateStatusStr: "Статус публікації",
        playDevice: "Пристрій відтворення",
        downloadView: "Переглянути завантаження",
        publisher: "Автор публікації",
        publishTime: "Час публікації",
        operation: "Операції",
        add: "Додати",
        groupName: "Назва групи",
        selectDevice: "Вибрати термінал",
        searchDevice: "Шукати термінал",
        pleaseFillGroupName: "Введіть назву групи！",
        remarkInfo: "Примітка",
        compile: "Редагувати",
        withdrawConfirm: "Підтвердити скасування цієї програми？",
        confirm: "Підтвердити",
        cancel: "Скасувати",
        withdraw: "Скасувати",
        batchWithdraw: "Пакетне скасування",
        batchPublish: "Пакетна публікація",
        batchDelete: "Пакетне видалення",
        batchOperation: "Пакетні операції",
        notUse: "Не використовується",
        notChecked: "Не перевірено",
        notPass: "Не схвалено",
        delete: "Видалити",
        publishTextLeft: "Опубліковано",
        offTextLeft: "Призупинено",
        pleaseSelectProgramToMove: "Виберіть програму для переміщення！",
        pause: "Призупинити",
        pauseConfirm: "Підтвердити призупинення？",
        play: "Відтворити",
        downloadUdisk: "Завантажити на USB-накопичувач",
        deviceList: "Список пристроїв",
        groupSelection: "Вибір групи",
        operationSuccess: "Операція успішна",
        deleteSuccess: "Видалено успішно",
        selectDate: "Вибрати дату",
        publishStatus: "Статус публікації",
        checkStatus: "Статус перевірки",
        waitAuditing: "Очікує перевірки",
        auditPass: "Перевірено успішно",
        auditRefuse: "Відхилено при перевірці",
        all: "Всі",
        playStatus: "Відтворюється",
        playStatust: "Статус відтворення",
        pauseStatus: "Призупинено",
        notStartStatus: "Не розпочато",
        resolutionratio: "Роздільна здатність",
        totalNum: "шт",
        programName: "Назва програми",
        playStartTime: "Час початку відтворення",
        playEndTime: "Час закінчення відтворення",
        createTime: "Час створення",
        nationality: "Національність",
        province: "Провінція",
        city: "Місто",
        county: "Район",
        address: "Адреса",
        ip: "IP-адреса",
        location: "Розташування",
        log: "Журнали",
        pleaseFillProgramName: "Введіть назву програми！",
        selectGroup: "Вибрати групу",
        startTime: "Час початку",
        endTime: "Час закінчення",
        publishCycle: "Цикл публікації",
        publishDeviceNum: "Кількість пристроїв для публікації",
        pleaseSelectRecord: "Виберіть запис",
        deviceName: "Назва терміналу",
        deviceId: "ID термінального пристрою",
        deviceGroupIdName: "Приналежність до групи",
        notClassified: "Не класифіковано",
        osTypeStr: "Операційна система терміналу",
        storageSpace: "Простір для зберігання",
        onLineStatus: "Статус підключення",
        onLine: "В мережі",
        offLine: "Поза мережею",
        sleep: "Спів",
        unknown: "Невідомо",
        registerStatus: "Статус реєстрації",
        trialPeriod: "Пробний період",
        notActive: "Не активовано",
        active: "Активовано",
        parameterError: "Невірні параметри!",
        pleaseSelectProgram: "Виберіть програму!",
        pleaseSelectProgramEdit: "Виберіть програму для редагування!",
        confirmWithdrawSelectedProgram: "Підтвердити скасування вибраних програм？",
        withdrawSuccess: "Скасовано успішно",
        allPrograms: "Всі програми",
        defaultGroup: "За замовчуванням",
        cannotShareEmptyProgram: "Неможливо поділитися порожньою програмою！",
        onlyShareYourProgram: "Можна поділитися лише власними програмами!",
        pleaseSelectProgramEditPublishTime: "Виберіть програму, для якої відредаговано час публікації!",
        pleaseSelectDevice: "Виберіть пристрій!",
        programDetail: "Деталі програми",
        errorReason: "Причина помилки",
        availableStorageSpaceInsufficient: "Недостатньо вільного простору для зберігання",
        partialDeviceReleaseFailure: "Публікація на частину пристроїв не вдалося",
        allDeviceReleaseSuccess: "Публікація на всі пристрої успішна",
        partialDeviceReleaseSuccess: "Публікація на частину пристроїв успішна",
        allGroup: "Всі групи",
        allProgram: "Всі програми",
        unGrouped: "Не згруповано",
        replaceProgram: "Замінити програму",
        replaceProgramTip: "Нова опублікована програма замінить дані програм, що були надіслані на термінал відтворення！",
        screen: "Один/два екрани",
        singleScreen: "Один екран",
        doubleScreen: "Два екрани",
        playSetting: "Налаштування відтворення",
        batchPlaySetting: "Пакетне налаштування часу відтворення",
        individualPlaySetting: "По черзі налаштування часу відтворення",
        playTime: "Час відтворення",
        daily: "Щодня",
        weekdays: "З понеділка по п'ятницю",
        monthly: "У поточному місяці",
        advancedSetting: "Розширені налаштування",
        playProgram: "Відтворити програму",
        searchProgram: "Введіть ключове слово",
        shareAddressNotExist: "Адреса для поділу не існує, спробуйте ще раз",
        copySuccess: "Скопійовано успішно",
        shareLink: "Посилання для поділу",
        publish: "Опублікувати",
        noResource: "Ресурсів немає",
        single: "Один екран",
        double: "Два екрани",
        time: "Час",
        associatedTerminalNum: "Кількість пов'язаних терміналів",
        default: "За замовчуванням",
        moveGroup: "Перемістити до групи",
        pleaseSelectGroup: "Введіть назву групи！",
        copy: "Копіювати",
        FUBEN: "Копія",
        nameempty: "Назва не може бути порожньою",
        whitespace: "Помилка іменування, ім'я файлу не може містити пробілів！",
        programWhitespace: "Помилка іменування, назва програми не може містити пробілів！",
        pleaseSelectResolution: "Виберіть роздільну здатність！",
        dataError: "Невірні дані！",
        createProgram: "Створити нову програму",
        directCreate: "Створити безпосередньо",
        myTemplate: "Мої шаблони",
        use: "Використовувати",
        free: "Безкоштовно",
        loadMore: "Завантажити ще",
        confirmDelete: "Підтвердити видалення",
        deleteGroup: "Видалити групу",
        notPublished: "Не опубліковано",
        notPassed: "Не схвалено",
        notUsed: "Не використовується",
        confirmDeleteSelectedProgram: "Підтвердити видалення вибраних програм？",
        companyName: "Назва підприємства",
        programCannotDownload: "Цю програму не можна завантажити！",
        publishMaterial: "Опублікувати матеріали",
        playMaterial: "Відтворити матеріали",
        pleaseInputMaterialName: "Введіть назву матеріалу",
        size: "Розмір",
        pleaseInputDeviceName: "Введіть назву пристрою",
        item: "шт",
        allMaterial: "Всі матеріали",
        allDevices: "Всі пристрої",
        "saveSuccess": "Збережено успішно",
        "savefaill": "Помилка збереження",
        "playMode": "Режим відтворення",
        "cyclePlay": "Циклічне відтворення",
        "insertPlay": "Вставне відтворення",
        "noData": "Даних немає",
        "Add": "Додати",
        "replace": "Замінити",
        "repeat": "Повторити",
        "start01": "Початок",
        "end01": "Кінець",
        "startDate": "Дата початку",
        "endDate": "Дата закінчення",
        "useNow": "Використати негайно",
        "fillStartEndTimeFirst": "Будь ласка, заповніть час початку та закінчення перед додаванням",
        "fillFullPlayTime": "Будь ласка, заповніть повний час відтворення",
        "fillCorrectPlayTime": "Будь ласка, заповніть правильний період відтворення",
        "sDateAndEDateBothEmptyOrFilled": "Дата початку та дата закінчення мають бути або обидві порожні, або обидві заповнені"
    },
    source: {
        addResource: "Додати ресурс",
        width: "Ширина",
        height: "Висота",
        size: "Розмір(КБ)",
        name: "Назва",
        pleaseInputResourceName: "Введіть назву ресурсу！",
        addToGroup: "Додати до групи",
        remark: "Примітка",
        promptFgIllustrate: "Ілюстрація",
        promptFgRealisticPhoto: "Реалістична фотографія",
        promptFgSimplisticDrawing: "Простий малюнок",
        promptFgChineseStyle: "Китайський стиль",
        promptFgPixelArt: "Піксельний стиль",
        noModel: "Моделей немає, зв'яжіться з адміністратором！",
        getModelFailed: "Не вдалося отримати моделі, спробуйте пізніше！Або зв'яжіться з адміністратором！",
        createImagePrompt: "Зображення генерується, закрийте пізніше！",
        promptEmpty: "Введіть запит",
        dpiEmpty: "Виберіть пропорцію зображення！",
        fgEmpty: "Виберіть стиль！",
        style: "Стиль",
        idEmpty: "ID зображення не може бути порожнім",
        exist: "Це зображення вже існує в матеріалах",
        addSuccess: "Матеріал додано успішно",
        saveError: "Не вдалося зберегти зображення, спробуйте пізніше！",
        delSuccess: "Видалено успішно",
        generateImage: "Текст у зображення",
        generateImagePlaceholder: "Введіть опис зображення, наприклад: Метелик танцює у квітковому полі",
        aiExpand: "Інтелектуальне розширення",
        negativePrompt: "Зворотний запит",
        negativePromptTooltip: "Використовується для чіткого виключення вмісту або ознак, які користувач не хоче бачити в результаті",
        imageRatio: "Пропорція зображення",
        generateImageBtn: "Згенерувати зараз",
        shengchengjieguo: "Результат генерації",
        generateImageLoadingTip: "Генерується, не натискайте повторно та не закривайте...",
        Tooltip: "Перетворіть вашу креативність за допомогою ІНТЕЛЕКТУ",
        saveToMaterial: "Зберегти в матеріали",
        publish: "Опублікувати зараз",
        download: "Завантажити",
        generateHistory: "Історія генерації",
        hide: "Згорнути",
        cancel: "Скасувати",
        useExpand: "Використовувати розширення",
        all: "Всі",
        delete: "Видалити",
        loadMore: "Завантажити ще",
        aiTip: "Вміст згенерований штучним інтелектом, не відображає погляди, позицію чи ставку платформи, використовуйте вміст ІНТЕЛЕКТУ відповідно до закону",
        operationSuccess: "Операція успішна",
        moveGroup: "Перемістити до групи",
        groupName: "Назва групи",
        pleaseSelectGroup: "Виберіть назву групи！",
        shenhe: "Перевірка",
        shenheStatus: "Статус перевірки",
        shenheSuccess: "Перевірено успішно",
        shenheRefuse: "Відхилено при перевірці",
        pleaseSelectShenheStatus: "Виберіть статус перевірки！",
        shenheRemark: "Примітка до перевірки",
        pleaseInputShenheRemark: "Введіть примітку до перевірки！",
        pleaseInputFileName: "Введіть ім'я файлу！",
        whitespace: "Помилка іменування, ім'я файлу не може містити пробілів！",
        dataError: "Невірні дані！",
        confirmDelete: "Підтвердити видалення",
        confirm: "Підтвердити",
        deleteFolder: "Видалити папку",
        add: "Додати",
        edit: "Редагувати",
        fileName: "Ім'я файлу",
        group: "Група",
        resolution: "Роздільна здатність",
        type: "Тип",
        image: "Зображення",
        music: "Музика",
        video: "Відео",
        uploadTime: "Час завантаження",
        uploadUser: "Користувач, який завантажив",
        checkTime: "Час перевірки",
        checkUser: "Користувач, який перевірив",
    },
    setting: {
        nameempty: "Назва не може бути порожньою",
        heightempty: "Висота не може бути порожньою",
        widthempty: "Ширина не може бути порожньою",
        resolutionratio: "Роздільна здатність",
        name: "Назва",
        opteration: "Операції",
        compile: "Редагувати",
        delete: "Видалити",
        newz: "Додати",
        compileratio: "Редагувати роздільну здатність",
        sheizhifenbianlvmingcheng: "Встановити назву роздільної здатності",
        shezhigaodu: "Встановити висоту",
        shezhikuandu: "Встановити ширину",
        xinzengfenbianlv: "Додати роздільну здатність",
        bianma: "Кодування",
        bianjizhongduanmingcheng: "Редагувати назву терміналу",
        xinzengzhongduan: "Додати термінал",
        selectPrimaryColor: "Вибрати основний колір теми",
        fullScreen: "На весь екран",
        exitFullScreen: "Вийти з повноекранного режиму",
    },
    tabs: {
        refresh: "Оновити",
        refreshAll: "Оновити все",
        close: "Закрити",
        closeOthers: "Закрити інші",
        closeAll: "Закрити все",
        closeLeft: "Закрити ліві",
        closeRight: "Закрити праві",
    },
    errorPage: {
        needLogin: "Ви ще не увійшли в систему！",
        pageNotFound: "Сторінка, яку ви запитуєте, не існує！",
        redirectTo: "Перенаправити на",
        orReturn: "або повернутися до",
        previousStep: "Попередній крок",
    },
    headerUs: {
        systemNotice: "Системні повідомлення",
        allNotices: "Всі повідомлення",
        viewAllMessages: "Переглянути всі повідомлення",
        contactUs: "Зв'язатися з нами",
        operationSuccess: "Операція успішна！",
        leaveMessage: "Залишити повідомлення",
        messageTitle: "Заголовок",
        messageTitleTip: "Введіть заголовок！",
        messageContentTip: "Не більше 150 символів",
        submit: "Відправити",
        markAsRead: "Позначити як прочитане",
        success: "Операція успішна！"
    },
    material: {
        allMaterial: "Всі матеріали",
        defaultGroup: "За замовчуванням",
        auditStatus: "Статус перевірки",
        auditPassed: "Перевірено успішно",
        auditRejected: "Відхилено при перевірці",
        pendingAudit: "Очікує перевірки",
        all: "Всі",
        operateSuccess: "Операція успішна！",
        pleaseSelectMaterial: "Виберіть матеріал！",
        moveGroup: "Перемістити до групи",
        pleaseSelectGroup: "Виберіть групу！",
        batchPublish: "Пакетна публікація",
        batchRecall: "Пакетне відкликання",
        batchDelete: "Пакетне видалення",
        materialList: "Список матеріалів",
        uploadMaterial: "Завантажити матеріали",
        materialType: "Тип матеріалу",
        pleaseInputMaterialName: "Введіть назву матеріалу",
        selectAll: "Вибрати все",
        confirmDeleteSelectedMaterial: "Підтвердити видалення вибраних матеріалів？",
        deleteSuccess: "Видалено успішно",
        delete: "Видалити",
        publish: "Опублікувати",
        recall: "Відкликати",
        confirmRecallSelectedMaterial: "Підтвердити відкликання вибраних матеріалів？",
        pleaseSelectMaterialGroup: "Виберіть групу матеріалів！",
        recallSuccess: "Відкликано успішно",
        publishSuccess: "Опубліковано успішно",
        batchOperate: "Пакетні операції",
        item: "шт",
        confirmDelete: "Підтвердити видалення？",
        edit: "Редагувати",
        confirmRecall: "Підтвердити відкликання？",
        unaudited: "Не перевірено",
        notPassed: "Не схвалено",
        operate: "Операції",
        resolution: "Роздільна здатність",
        none: "Відсутнє",
        confirm: "Підтвердити",
        cancel: "Скасувати",
        AICreation: "Створення за допомогою ІНТЕЛЕКТУ",
    },
    uploadFile: {
        operationSuccess: "Операція успішна",
        uploadFile: "Керування завантаженням",
        uploadSuccess: "Завантажено успішно",
        uploadCompleted: "Завантаження завершено",
        uploadFail: "Завантаження не вдалося",
        ConversionFailed: "Конвертація не вдалося！",
        loading: "Завантаження...",
        beQueuing: "В черзі...",
        Uploading: "Завантаження...",
        ConversionIng: "Конвертація...",
        ConventionalResources: "Звичайні ресурси",
        DocumentResources: "Документальні ресурси",
        complete: "Завершено",
        upload: "Завантажити",
        fileSizeWraning01: "Розмір матеріалу перевищує",
        fileSizeWraning02: "Змініть та завантажте знову！",
        fileIsEmpty: "Файл порожній",
        uploadFileTip: "Непідтримуваний формат файлу",
        unablePreview: "Не вдалося додати до бібліотеки матеріалів, перегляд неможливий",
        confirmDelete: "Підтвердити видалення？",
        deleteSuccess: "Видалено успішно",
        delete: "Видалити",
        confirm: "Підтвердити",
        preview: "Перегляд",
        close: "Закрити",
        cancel: "Скасувати",
        fileType: "Тип файлу",
        fileSize: "Розмір файлу",
        conversionProgress: "Прогрес конвертації",
        progress: "Прогрес",
        image: "Зображення",
        video: "Відео",
        audio: "Музика",
        limitTip01: "Одночасне завантаження",
        limitTip02: "файлів",
        okTip: "Матеріал завантажується, закрийте пізніше！",
        usableSize: "Доступний обсяг",
        sizeUnableTip: "Недостатньо вільного простору для зберігання, будь ласка, видаліть непотрібні матеріали, щоб звільнити місце, або зв'яжіться з дилером для розширення обсягу.",
        view: "Переглянути деталі",
        fileName: "Ім'я файлу",
    },
    template: {
        inputPlaceholder: "Введіть",
        selectPlaceholder: "Виберіть",
        noAuths: "Немає прав доступу, зв'яжіться з адміністратором",
        operationSuccess: "Операція успішна",
        total: "Всього",
        totalNum: "шт",
        dan: "Один",
        shaung: "Два",
        pleaseSelectGroup: "Виберіть групу",
        preview: "Перегляд",
        free: "Безкоштовно",
        use: "Використовувати",
        dpi: "Роздільна здатність",
        delete: "Видалити",
        confirmDelete: "Підтвердити видалення",
        confirmDeleteSelectedTemplate: "Підтвердити видалення цього шаблону",
        push: "Опублікувати",
        pushConfirm: "Підтвердити публікацію в загальні шаблони",
        pushRemovalConfirm: "Підтвердити зняття з загальних шаблонів",
        templateOrderRecord: "Історія замовлень шаблонів",
        unpublished: "Не опубліковано",
        auditing: "Перевіряється",
        publishRejected: "Відхилено при публікації",
        publishSuccess: "Опубліковано успішно",
        offShelf: "Зняти з продажу",
        公共模版: "Загальні шаблони",
        我的模板: "Мої шаблони",
        共享记录: "Історія поділу",
        name: "Назва",
        pubdate: "Час публікації",
        keySeachTip: "Введіть ключове слово",
        allGroup: "Всі групи",
        add: "Додати",
        edit: "Редагувати",
        programName: "Назва програми",
        selectGroup: "Вибрати групу",
    },
    checkManage: {
        total: "Всього",
        totalNum: "шт",
        operationSuccess: "Операція успішна",
        checkUserLogs: "Історія перевірок (оператор)",
        checkLogs: "Історія перевірок (аудитор)",
        sourceCheck: "Перевірка матеріалів",
        programCheck: "Перевірка програм",
        checkAll: "Вибрати все",
        auditPass: "Перевірено успішно",
        auditRefuse: "Відхилено при перевірці",
        auditPass01: "Схвалено",
        auditRefuse01: "Відхилено",
        auditRefuse02: "Відхилити перевірку",
        auditor: "Аудитор",
        agentUserName: "Автор публікації",
        interrogationTime: "Час подання на перевірку",
        checkTime: "Час перевірки",
        checkName: "Назва перевірки",
        checkType: "Категорія перевірки",
        checkIp: "IP-адреса подання на перевірку",
        checkReason: "Повідомлення",
        checkStatus: "Вміст операції",
        rangePicker: "Дата перевірки",
        keyWord: "Ключове слово",
        all: "Всі",
        program: "Програма",
        material: "Матеріал",
        dan: "Один",
        shaung: "Два",
        pleaseSelectProgram: "Виберіть програму!",
        pleaseSelectMaterial: "Виберіть матеріал！",
        preview: "Перегляд",
        dpi: "Роздільна здатність",
        auditRefuseTip: "Введіть причину відхилення",
        unreviewed: "Не перевірено",
        notPassed: "Не схвалено",
        notUsed: "Не використовується",
        edit: "Редагувати",
        none: "Відсутнє",
        name: "Назва",
        size: "Розмір",
        type: "Тип",
        uploadTime: "Час завантаження",
        uploadUser: "Користувач, який завантажив",
        checkUser: "Користувач, який перевірив",
        image: "Зображення",
        music: "Музика",
        video: "Відео",
    },
    systemSet: {
        total: "Всього",
        totalNum: "шт",
        inputPlaceholder: "Введіть",
        selectPlaceholder: "Виберіть",
        userList: "Члени організації",
        roleList: "Права ролей",
        department: "Структура організації",
        diskInfo: "Простір для зберігання",
        approveSet: "Схвалення вмісту",
        logList: "Керування журналами",
        name: "Ім'я",
        account: "Обліковий запис",
        userName: "Ім'я користувача",
        phoneNumber: "Номер телефону",
        role: "Роль",
        createTime: "Час створення",
        operation: "Операції",
        edit: "Редагувати",
        delete: "Видалити",
        addNew: "Додати",
        add: "Додати",
        resetPassword: "Скинути пароль",
        confirmDelete: "Підтвердити видалення",
        departmentOrganization: "Відділи установи",
        addNewUser: "Додати нового користувача",
        pleaseEnterUserName: "Введіть ім'я користувача",
        confirmPasswordNotMatch: "Підтверджений пароль не збігається з введеним паролем!",
        operationSuccess: "Операція успішна！",
        userNickname: "Ім'я користувача",
        pleaseEnterUserNickname: "Введіть ім'я користувача",
        userNicknameRequired: "Ім'я користувача не може бути порожнім！",
        password: "Пароль",
        pleaseEnterPassword: "Введіть пароль",
        passwordRequired: "Пароль не може бути порожнім！",
        passwordTip: "Безпека вашого паролю занадто низька (пароль повинен містити будь-які 3 типи: великі літери, малі літери, цифри, спеціальні символи) і довжина",
        confirmPassword: "Підтвердити пароль",
        pleaseEnterPhoneNumber: "Введіть номер телефону",
        phoneNumberRequired: "Номер телефону не може бути порожнім！",
        phoneNumberFormatError: "Введіть правильний номер телефону！",
        roleRequired: "Роль не може бути порожньою！",
        required: "Не може бути порожнім！",
        departmentName: "Відділ",
        modifyPassword: "Змінити пароль",
        newPassword: "Новий пароль",
        pleaseEnterNewPassword: "Введіть новий пароль",
        pwdMessage: "Довжина паролю 8~20 символів, не містить пробілів і обов'язково включає 3 з наступних типів: великі літери, малі літери, цифри, спеціальні символи",
        all: "Всі",
        noAuths: "Немає прав доступу, зв'яжіться з адміністратором",
        departmentName01: "Назва відділу",
        image: "Зображення",
        music: "Музика",
        video: "Відео",
        buySize: "Кількість покупок",
        totalMoney: "Сума платежу",
        buycreateTime: "Час покупки",
        endTime: "Час закінчення",
        buyTypeStr: "Тип замовлення",
        sourceCheck: "Перевірка матеріалів",
        programCheck: "Перевірка програм",
        programName: "Назва програми",
        diskExpansion: "Рекомендується регулярно видаляти застарілі/непотрібні матеріали під час використання, щоб забезпечити вільний простір системи. Якщо вам потрібен більший обсяг, ви можете зв'язатися з постачальником вашого обладнання для отримання послуги розширення обсягу хмарного сховища. Ця послуга може стягнуватися, деталі дивіться у дилера.",
        selectPermission: "Виберіть права доступу",
        checkPermission: "Відмітьте права доступу",
        addRole: "Додати роль",
        enterRoleName: "Введіть назву ролі",
        roleName: "Назва ролі",
        roleNameRequired: "Назва ролі не може бути порожньою！",
        remark: "Примітка",
        enterRemark: "Введіть примітку",
        permissionSetting: "Налаштування прав доступу",
        deleteSuccess: "Видалено успішно！",
        confirmToDelete: "Підтвердити видалення？",
        orgName: "Назва установи",
        orgNameRequired: "Назва установи не може бути порожньою！",
        orgRemark: "Примітка до установи",
        enterOrgRemark: "Введіть примітку до установи",
        capacityUsage: "Статус використання обсягу",
        usedCapacity: "Використаний обсяг",
        totalCapacity: "Загальний обсяг",
        remainingCapacity: "Залишковий обсяг",
        capacityExpansion: "Розширення обсягу",
        enable: "Увімкнути",
        disable: "Вимкнути",
        userName01: "Ім'я користувача",
        loginTime: "Час входу",
        ipAddress: "IP-адреса",
        loginResult: "Результат входу",
        selectDate: "Вибрати дату",
        enterDate: "Виберіть дату",
        selectStartTime: "Виберіть час початку",
        selectEndTime: "Виберіть час закінчення",
        enterUserName: "Введіть ім'я користувача",
        userCount: "Кількість користувачів",
        roleDesc: "Опис ролі",
        roleAuthorization: "Авторизація ролі",
        success: "Успішно",
        failure: "Не вдалося",
        time: "Час",
        operationContent: "Вміст операції",
        playCount: "Кількість відтворень",
        playDuration: "Тривалість відтворення",
        selectDevice: "Вибрати пристрій",
        enterProgramName: "Введіть назву програми",
        serialNumber: "Порядковий номер",
        publishContentName: "Назва опублікованого вмісту",
        playMode: "Спосіб відтворення",
        cyclePlay: "Циклічне відтворення",
        insertPlay: "Вставне відтворення",
        paddingPlay: "Додаткове відтворення",
        playDeviceId: "ID пристрою відтворення",
        playDeviceName: "Назва пристрою відтворення",
        publishTime: "Час публікації",
        downloadStatus: "Статус завантаження",
        notDownloaded: "Не завантажено",
        downloading: "Завантажується",
        downloadSucceeded: "Завантажено успішно",
        downloadFailed: "Завантаження не вдалося",
        enterPublishContentName: "Введіть назву опублікованого вмісту",
        terminalId: "ID термінала",
        belongOrg: "Приналежність до установи",
        reportTime: "Час звіту",
        reportIp: "IP-адреса звіту",
        logInfo: "Інформація в журналі",
        details: "Деталі",
        confirmDeletion: "Підтвердити видалення？",
        logDetails: "Деталі журналу",
        download: "Завантажити",
        deptOrg: "Відділи установи",
        query: "Запит",
        queryByTerminalId: "Запит за ID термінала",
        batchDeleteLogs: "Пакетне видалення журналів",
        customTimeDeleteLogs: "Видалення журналів за користувацьким часом",
        selectTimeRangeFirst: "Спочатку виберіть діапазон часу",
        deleteAllDeviceLogsIfEmpty: "Якщо не вказати ID пристрою, за замовчуванням будуть видалені журнали всіх пристроїв",
        enterDeviceIdToDeleteLogs: "Введіть ID пристрою, журнали якого потрібно видалити",
        confirmDeleteAction: "Підтвердити видалення",
        selectDeleteRangeFirst: "Спочатку виберіть діапазон видалення",
        networkConnectionFailed: "Помилка підключення до мережі",
        playLog: "Журнали відтворення",
        publishLog: "Журнали публікації",
        errorLog: "Журнали помилок",
        operationLog: "Журнали операцій",
        fileLog: "Журнали файлів",
        userOperateLog: "Журнали входу",
    },
    userManual: {
        userManual: "Інструкція користувача",
        noData: "Даних немає",
    },
    systemNotice: {
        systemNotice: "Системні повідомлення",
        noData: "Даних немає",
        total: "Всього",
        totalNum: "шт",
        "markAllRead": "Позначити все як прочитане",
        "deleteAll": "Видалити все",
        "all": "Всі",
        "unread": "Непрочитане",
        "read": "Прочитане",
        "type": "Тип",
        "content": "Вміст",
        "date": "Дата",
        "status": "Статус",
        "confirmDelete": "Підтвердити видалення？",
        "confirm": "Підтвердити",
        "cancel": "Скасувати",
        "delete": "Видалити"
    }
};